/**
 * @description 設置投保類型 (新保 or 續保)
 */
export enum InsureTypesEnum {
  /** 新保 */
  Insure = 'insure',
  /** 續保 */
  Renewal = 'renewal'
}
